<template functional>
  <i
    :style="{fontSize: props.iconSize, color: props.iconColor}"
    :class="['icons', 'base-icons', `icons-${props.iconName}`, data.staticClass]"
  ></i>
</template>

<script>
export default {
  name: 'BaseIcon',
  props: {
    iconColor: {
      type: String,
      default: '',
    },
    iconSize: {
      type: String,
      default: '',
    },
    iconName: {
      type: String,
      default: '',
    },
  },
};
</script>
<style>
  .base-icons {
    font-size: 24px;
  }
</style>
